import {
    // FILE_UPLOAD,
    CREATE_NOTIFICATION,
    RETRIEVE_NOTIFICATION,
    RETRIEVESINGLE_NOTIFICATION,
    UPDATE_NOTIFICATION,
    DELETE_NOTIFICATION,
} from "./type";
import Notification from "../service/Notification";
export const create = (data) => async (dispatch) => {
    try {
        const res = await Notification.create(data);
        dispatch({
            type: CREATE_NOTIFICATION,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await Notification.fetchList(data);
        dispatch({
            type: RETRIEVE_NOTIFICATION,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await Notification.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_NOTIFICATION,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await Notification.update(data);
        dispatch({
            type: UPDATE_NOTIFICATION,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await Notification.changeStatus(data);
//         dispatch({
//             type: UPDATE_NOTIFICATION,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await Notification.trash(data);
        dispatch({
            type: DELETE_NOTIFICATION,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};